<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
  <template v-slot:activator="{ on, attrs }">
    <v-icon
      color="blue darken-2"
      dark
      v-bind="attrs"
      v-on="on"
      class="mx-1"
    small>fas fa-eye</v-icon>
  </template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ project.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="dialog = false">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="px-10">
    <v-row class="ma-0">
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Title</label>
        <h3 class="font-weight-regular">{{ project.title }}</h3>
      </v-col >
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Category</label>
        <h3 class="font-weight-regular">{{ project.category }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Start Date</label>
        <h3 class="font-weight-regular">{{ project.start_date }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Deadline Date</label>
        <h3 class="font-weight-regular">{{ project.deadline_date }}</h3>
      </v-col>
    </v-row>
     <v-row class="ma-0">
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Client</label>
        <h3 class="font-weight-regular">{{ project.client.name }}</h3>
      </v-col >
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Leader</label>
        <h3 class="font-weight-regular">{{ project.leader.name }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Assign To</label>
        <h3 class="font-weight-regular">{{ project.assignto.name }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Status</label>
        <h3 class="font-weight-regular">{{ project.project_status }}</h3>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Quoted Amount</label>
        <h3 class="font-weight-regular">{{ project.quoted_amount }}</h3>
      </v-col >
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Paid Amount</label>
        <h3 class="font-weight-regular">{{ project.paid_amount }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Work Status</label>
        <h3 class="font-weight-regular">{{ project.work_status }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Project Payment Status</label>
        <h3 class="font-weight-regular">{{ project.payment_status }}</h3>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" sm="12" md="12">
        <label class="body-2">Project Description</label>
        <h3 class="font-weight-regular">{{ project.description }}</h3>
      </v-col >
    </v-row>
    <v-row class="py-2 ma-0">
      <v-col cols="12">
      <h4>Project Details</h4>
      <hr/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <ProjectClient :client="project.client" />
      </v-col>
      <v-col cols="3" class="pl-0">
         <ProjectComments :comments="project.comments" :projectid="project.id" />
      </v-col>
      <v-col cols="6">
        <v-card>
      <v-tabs
        background-color="white"
        color="deep-purple accent-4"
        left
      >
      <v-tab>Contacts</v-tab>
      <v-tab>Files</v-tab>

      <v-tab-item
        :key="1"
      >
        <v-container fluid>
          <ProjectContact :contacts="project.contacts" :projectid="project.id" />
        </v-container>
      </v-tab-item>

      <v-tab-item
        :key="2"
      >
        <v-container fluid>
          <ProjectFiles :files="project.files" :projectid="project.id" />
        </v-container>
      </v-tab-item>
    </v-tabs>
    </v-card>
      </v-col>
    </v-row>
   
    </div>
  </v-card>
</v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectClient from './ProjectClient.vue';
import ProjectContact from './ProjectContact.vue';
import ProjectFiles from './ProjectFiles.vue';
import ProjectComments from './ProjectComments.vue';
  export default {
    components: {
      ProjectClient,
      ProjectContact,
      ProjectFiles,
      ProjectComments,
    },
    props: {
      project: Object,
      projectid : Number
    },
    data: function() {
      return {
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      dialog: false,
      }
    },
    computed: {
      ...mapGetters(["allprojects"]),
    }

  }
</script>